import { graphql } from 'react-relay';

import ContentIssueTable from './containers/ContentIssueTable';
import DescriptionIssueTable from './containers/DescriptionIssueTable';
import H1IssueTable from './containers/H1IssueTable';
import OnPageCategory from './containers/OnPageCategory';
import TitleIssueTable from './containers/TitleIssueTable';

import { createRenderFunction } from '../../utils/redirects';

export default ({
  path: 'on-page',
  Component: OnPageCategory,
  query: graphql`
    query onpage_OnPageCategory_Query($host: String!) {
      project(host: $host) {
        ...OnPageCategory_project
      }
    }
  `,
  render: createRenderFunction({ redirectTo: '/title-issues' }),
  prepareVariables: params => ({ ...params, host: params.url }),
  children: [
    {
      Component: TitleIssueTable,
      path: 'title-issues',
      query: graphql`
        query onpage_OnPageCategory_TitleIssueTable_Query($host: String!) {
          project(host: $host) {
            ...TitleIssueTable_project
          }
        }
      `
    },
    {
      Component: DescriptionIssueTable,
      path: 'description-issues',
      query: graphql`
        query onpage_OnPageCategory_DescriptionIssueTable_Query($host: String!) {
          project(host: $host) {
            ...DescriptionIssueTable_project
          }
        }
      `
    },
    {
      Component: H1IssueTable,
      path: 'h1-issues',
      query: graphql`
        query onpage_OnPageCategory_H1IssueTable_Query($host: String!) {
          project(host: $host) {
            ...H1IssueTable_project
          }
        }
      `
    },
    {
      Component: ContentIssueTable,
      path: 'content-issues',
      query: graphql`
        query onpage_OnPageCategory_ContentIssueTable_Query($host: String!) {
          project(host: $host) {
            ...ContentIssueTable_project
          }
        }
      `
    }
  ]
});
